import { useTranslation } from "react-i18next";
import { usePushPermissionWarning } from "@/contexts/PushPermissionContext";


function MobileAppNotificationWarning() {
  const { t } = useTranslation();
  const { showWarning, requestPermission } = usePushPermissionWarning();

  if (!showWarning) return null;

  return (
    <div className="my-4 flex w-full flex-col items-start justify-between gap-5 rounded-md border border-yellow-300 bg-yellow-100 px-4 py-4 text-yellow-800 lg:flex-row lg:items-center lg:gap-2">
      <p className="text-sm sm:text-base">
      {t("mobileAppNotification.prompt")}

      </p>
      <button
        onClick={requestPermission}
        className="self-end rounded bg-yellow-300 px-4 py-2 font-semibold text-yellow-800 transition duration-150 ease-in-out hover:bg-yellow-400"
      >
        {t("mobileAppNotification.enable")}
      </button>
    </div>
  );
}

export default MobileAppNotificationWarning;
